var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareWideDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 32,
    viewBox: "0 0 79 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.902344,
    y: 0.5,
    width: 77.6,
    height: 31,
    rx: 3.5,
    fill: "#121B18"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.902344,
    y: 0.5,
    width: 77.6,
    height: 31,
    rx: 3.5,
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3699 10.6665V13.3332C35.9866 14.0185 34.3566 17.8585 33.7033 21.3332C33.6786 21.4705 37.2926 17.3585 40.3699 17.3332V19.9998L45.7033 15.3332L40.3699 10.6665Z",
    stroke: "#00FFE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWideDark);
export default __webpack_public_path__ + "static/media/shareWideDark.6cf491938db798bf8f6d6dffd5fb646a.svg";
export { ForwardRef as ReactComponent };